<span
    class="d-flex align-items-center"
    [inlineSVG]="filePath"
    [tippy]="hintText"
    [appendTo]="appendTo"
    [variation]="variation"
    [placement]="placement">
</span>
